module.exports = __webpack_public_path__ + "img/8.17bb1317.jpg";